import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { memo } from "react";
import clsx from "clsx";
import FooterTheme from "@/contexts/themeContext/FooterTheme";

type FooterLayout1Props = { className?: string };

/**
 * The footer layout 1.
 */
function FooterLayout1(props: FooterLayout1Props) {
	const { className } = props;

	return (
		<FooterTheme>
			<AppBar
				id="fuse-footer"
				position="static"
				className={clsx("z-20 border-t sticky bottom-0", className)}
				color="default"
				sx={(theme) => ({
					backgroundColor: theme.vars.palette.primary.main,
					color: theme.vars.palette.primary.contrastText,
					overflow: "hidden",
				})}
				elevation={0}
			>
				<Toolbar
					variant="dense"
					disableGutters
					className="flex items-center justify-end px-4 py-0 md:px-6"
					sx={{
						minHeight: 28,
						lineHeight: 1,
						"@media (min-width:600px)": {
							minHeight: 28,
						},
					}}
				>
					<span className="text-xs whitespace-nowrap font-semibold leading-none">
						Space Software{" "}
						<span className="mx-0.5 inline-flex items-center align-middle text-[0.9em] leading-none">
							&reg;
						</span>{" "}
						2026
					</span>
				</Toolbar>
			</AppBar>
		</FooterTheme>
	);
}

export default memo(FooterLayout1);
